///<reference path="../../../typings/angularjs/angular.d.ts"/>

module TaskList {
    export var app = angular.module("frendsTaskList", ["frends-utils", "ui.bootstrap"]);
}